var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":_vm.title,"sub-title":_vm.subTitle}},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.log},scopedSlots:_vm._u([{key:"cell()",fn:function(row){return [_vm._v(" "+_vm._s(row.value || "---")+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }